import { AdminFormSection } from '@ui';
import { FacilityLocationDetails } from '@lp/features/admin/forms/components/FacilityLocationDetails';
import { NewOpoForm } from '../types';
import { TextFieldRow } from './TextFieldRow';

type OpoFormType = {
  isReadOnly?: boolean;
};

export const OpoForm = ({ isReadOnly = false }: OpoFormType) => {
  return (
    <AdminFormSection title="OPO Details">
      <TextFieldRow<NewOpoForm> title="OPO Name" name="name" ariaLabel="OPO Name" isRequired isReadOnly={isReadOnly} />
      <TextFieldRow<NewOpoForm> title="Code" name="code" ariaLabel="Code" isRequired isReadOnly={isReadOnly} />
      <FacilityLocationDetails isReadOnly={isReadOnly} />
    </AdminFormSection>
  );
};
